// extracted by mini-css-extract-plugin
export default {"root":"highlighted_elements_root__8dfl1","carousel":"highlighted_elements_carousel__ZYIld","title":"highlighted_elements_title__+1OHK"};